import React from "react";
import ButtonComponent from "../../components/UI/ButtonComponent/ButtonComponent";
import { Form } from "react-bootstrap";
import "../../containers/ControlMeasures/ControlMeasures.css";
import DatePickerComponent from "../../components/UI/DatePicker/DatepickerComponent";
import ModalComponent from "../../components/UI/Modal/Modal";

const unosDatumaBrisanja = (props) => {
  return (
    <>
      <ModalComponent
        size="m"
        show={props.modalDatBrisanja}
        onHide={props.hideModalUnosDatBrisanja}
        title="Unos datuma brisanja"
      >
        <div className="row justify-content-center" key={"form"}>
          <div className="align-self-center">
            <Form onSubmit={props.submitHandlerDatBrisanja}>
              <div
                className="datepicker-modal"
                style={{ marginBottom: "20px" }}
              >
                <DatePickerComponent
                  required
                  errorBorderColor={props.error && !props.datBrisanja && "red"}
                  id="datBrisanja"
                  handleDayClick={props.datePickerHandlerDB}
                  controlLabel={"Datum brisanja"}
                  //selectedDays={props.datBrisanja}
                  index={{ id: "datBrisanja" }}
                  width={"100%"}
                />
              </div>

              <div className="row" key={"button"}>
                <div className="col-md-6">
                  <ButtonComponent
                    type="submit"
                    block={true}
                    variant="primary"
                    // onClick={props.hideModalUnosDatBrisanja}
                  >
                    Spremi
                  </ButtonComponent>
                </div>
                <div className="col-md-6">
                  <ButtonComponent
                    onClick={props.hideModalUnosDatBrisanja}
                    block={true}
                    variant="danger"
                    style={{ marginRight: "7px" }}
                  >
                    Odustani
                  </ButtonComponent>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </ModalComponent>
    </>
  );
};

export default unosDatumaBrisanja;
